export const BuPath = {
  DIST: ['DISTRIBUTION', 'FORESTRY'],
  GEN: ['GENERATION', 'PROJSOLUTIONS'],
  TRANS: 'TRANSMISSION',
};
